import React from "react";
import ProductMaster from "./ProductMaster";
import SpecTypeMaster from "./SpecTypeMaster";
import SpecValuesMaster from "./SpecValuesMaster";
import AdminMasterProducts from "./AdminMasterProducts";

const AdminProducts = () => {
  // We remove the extra card wrappers here because we already added 
  // the high-fidelity styling INSIDE the Master components themselves.
  
  return (
    <div className="container-fluid p-0">

      {/* 1. MASTER PRODUCT CREATION SECTION */}

      <div className="mb-5">
        <AdminMasterProducts />
      </div>
      
      {/* 1. PRODUCT MANAGEMENT SECTION */}
      <div className="mb-5">
        <ProductMaster />
      </div>

      {/* 2. SPEC TYPE MASTER SECTION - Now Full Width */}
      <div className="mb-5 pt-4 border-top">
        <SpecTypeMaster />
      </div>

      {/* 3. SPEC VALUES MASTER SECTION - Now Full Width */}
      <div className="mb-5 pt-4 border-top">
        <SpecValuesMaster />
      </div>

    </div>
  );
};

export default AdminProducts;